import axios from '../config/axios';
import { notification } from 'antd';
import {getResponseHandler,header,mainHeader} from './commonService'

const proposal = {
     
    getProposal : async (data={}) => {
        try{
            let rowData;
            rowData = await axios.get('/proposals/',header(data,1))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    }, 
    addProposal : async (data={}) =>{
        try{
            const rowData = await axios.post('/proposals',header(data,1))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    },
    myproposals : async (data={}) =>{
        try{
            const rowData = await axios.post('/proposals/myproposals',header(data,1))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    },
    myproductproposal : async (data={}) =>{
        try{
            const rowData = await axios.post('/proposals/myproductproposal',header(data,1))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    },
    changeStatus : async (data = {}) => {
        try{
            const rowData = await axios.post('/proposals/statusChange',header(data,1))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message });
        }
    },


    generateinvoicepdf : async (data={}) =>{
        try{
            const rowData = await axios.post('/proposals/generateinvoicepdf',header(data,1))
            const response = await rowData;
            //console.log(response);
            return response;               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    },

    getMyAllProposals : async (data={}) =>{
        try{
            const rowData = await axios.post('/proposals/getMyAllProposals',{}, header(data,1))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    }
}


export default proposal
